<template>
  <v-progress-linear v-if="carga < 9999" :value="porcentajeCarga" rounded background-opacity="0.1" :color="colorBarra" />
</template>

<script>
export default {
  props:{
    carga: {
      required: true,
    }
  },
  computed: {
    porcentajeCarga() {
      if (!this.carga)
        return 9999;

      let x = parseInt (this.carga);
      if (x < 0)
        x = 0;
      else if (x > 2000)
        x = 2000;
      x = x * 100 / 2000;
      if (x < 7) x = 7;
      return x;
    },
    colorBarra() {
      if (this.carga > 999)
        return '#64DD17'; // verde que te quiero verde
      else if (this.carga > 299)
        return '#FF8F00'; // naranja
      else if (this.carga > 0)
        return '#FF2222'; // rojo
      else
        return '#000000'; // de color, o sea, negro!
    }
  }
}
</script>

<style>

</style>